import React from "react";
import { Box, CircularProgress } from "@material-ui/core";
import { BRAND } from "src/theme/brandTokens";

const ProposalLoadingV2 = () => (
  <Box
    sx={{
      minHeight: "100vh",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 3,
      bgcolor: BRAND.color.paper,
      fontFamily: BRAND.font.family.base,
    }}
  >
    <CircularProgress
      size={60}
      thickness={4}
      sx={{ color: BRAND.color.primary }}
    />
    <Box
      sx={{
        fontSize: BRAND.font.size.eyebrow,
        color: BRAND.color.grey50,
        textTransform: "uppercase",
        letterSpacing: BRAND.font.letterSpacing.widest,
        fontWeight: BRAND.font.weight.medium,
      }}
    >
      Cargando propuesta…
    </Box>
  </Box>
);

export default ProposalLoadingV2;
